<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @searchChange="handleSearchChange"
      tableCardTitle="FINANCIAL REPORT"
    >
      <template v-slot:cardTitleRight>
        <div>
          <customize-button
            type="primary"
            style="margin-right: 24px"
            @click="handleAddBtn"
          >
            Add
          </customize-button>
        </div>
      </template>
      <template v-slot:action="{ tableRow }">
        <el-popconfirm
          title="Confirm to delete？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleRemoveItem(tableRow.row.id)"
        >
          <a
            href="javascript:void (0);"
            class="icon-trash1"
            slot="reference"
            style="color: #3a3f63"
          />
        </el-popconfirm>
        <!-- <a
          href="javascript:void(0)"
          class="icon-trash1"
          :id="tableRow.id"
          style="margin-right: 20px; color: #3a3f63"
          @click="handleRemoveItem(tableRow.row.id)"
        /> -->
      </template>
      <template v-slot:name="{ tableRow }">
        <el-link type="primary" @click="handleDownloadItem(tableRow.row)">
          {{ tableRow.row.financialReportName }}
        </el-link>
      </template>
      <template v-slot:type="{ tableRow }">
        {{ tableRow.row.type | type(typeList) }}
      </template>
      <template v-slot:reportYear="{ tableRow }">
        {{ tableRow.row.reportYear }}
        <span v-if="tableRow.row.reportQuarter">
          - {{ tableRow.row.reportQuarter | q(QList) }}
        </span>
      </template>
      <template v-slot:accountType="{ tableRow }">
        {{ filterNameAccountType(tableRow.row.accountType) }}
      </template>
      <template v-slot:auditorsOpinion="{ tableRow }">
        {{ filterNameAuditorsOpinion(tableRow.row.auditorsOpinion) }}
      </template>
    </table-view>
    <el-dialog
      title="Add"
      :visible.sync="visible"
      width="520px"
      @close="handleClose"
      :close-on-click-modal="false"
    >
      <el-card shadow="never">
        <el-form ref="form" label-position="top" :model="form">
          <el-form-item label="Financial Report Type" prop="type">
            <el-select v-model="form.type" style="width: 100%" filterable>
              <el-option
                v-for="item in this.typeList"
                :label="item.name"
                :value="item.id"
                :key="item.name"
              />
            </el-select>
          </el-form-item>
          <el-row>
            <el-form-item label="Financial Report Time" prop="reportYear">
              <el-col :span="form.type === 2 ? 11 : 24">
                <el-date-picker
                  value-format="yyyy"
                  style="width: 100%"
                  type="year"
                  v-model="form.reportYear"
                />
              </el-col>
              <el-col :span="12" v-show="form.type === 2" :push="1">
                <el-select v-model="form.reportQuarter" style="width: 100%">
                  <el-option
                    v-for="item in this.QList"
                    :label="item.name"
                    :value="item.id"
                    :key="item.name"
                  />
                </el-select>
              </el-col>
            </el-form-item>
          </el-row>
          <el-form-item label="Period Ending" prop="fiscalYearEndDate">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="form.fiscalYearEndDate"
              style="width: 100%"
              filterable
            />
          </el-form-item>

          <el-form-item label="Currency" prop="currency">
            <el-select
              v-model="form.currency"
              style="width: 100%"
              filterable
              @change="handleChangeCurrency"
            >
              <el-option
                v-for="item in this.currencyList"
                :label="item.currencyName"
                :value="item.currency"
                :key="item.currency"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="Exchange Date"
            v-if="form.currency !== 'USD'"
            prop="exchangeDate"
          >
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              v-model="form.exchangeDate"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="Exchange Rate(USD)"
            v-if="form.currency !== 'USD'"
            prop="exchangeRate"
          >
            <el-input :disabled="true" v-model="form.exchangeRate"></el-input>
          </el-form-item>
          <el-form-item label="Account Type" prop="accountType">
            <el-select style="width: 100%" v-model="form.accountType">
              <el-option :value="1" label="Consolidated" />
              <el-option :value="2" label="Stand alone" />
            </el-select>
          </el-form-item>
          <el-form-item label="Auditors'opinion" prop="auditorsOpinion">
            <el-select style="width: 100%" v-model="form.auditorsOpinion">
              <el-option :value="1" label="Unqualified" />
              <el-option :value="2" label="With Remarks" />
              <el-option :value="3" label="Qualified" />
              <el-option :value="4" label="Non-audited" />
            </el-select>
          </el-form-item>
        </el-form>
        <el-upload
          :auto-upload="false"
          :action="uploadUrl"
          :headers="{ Authorization: $store.state.token }"
          :data="{ companyId: this.$route.params.customerId }"
          :file-list="fileList"
          :show-file-list="false"
          :on-change="handleChange"
        >
          <customize-button style="width: 100%">
            Upload Documents
          </customize-button>
        </el-upload>
        <el-link
          type="primary"
          :underline="false"
          class="download-template-btn"
          @click="handleTemplateDownload"
        >
          Download Template
        </el-link>
        <div class="file-wrapper" v-if="fileList.length">
          {{ fileList[0].name }}
        </div>
      </el-card>
      <div slot="footer">
        <customize-button @click="visible = false" style="margin-right: 14px">
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleSubmit">
          Submit
        </customize-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTableData,
  getCurrencyList,
  addCompanyFinances,
  templateDownload,
  removeItem,
  getCurrenyRate,
} from './api'
import { commonUploadUrl, commonDownload, commonUpload } from '@/api'
export default {
  data() {
    this.QList = [
      {
        id: 5,
        name: 'H1',
      },
      {
        id: 6,
        name: 'H2',
      },
      {
        id: 1,
        name: 'Q1',
      },
      {
        id: 2,
        name: 'Q2',
      },
      {
        id: 3,
        name: 'Q3',
      },
      {
        id: 4,
        name: 'Q4',
      },
    ]
    this.currencyList = []
    const searchModel = [
      {
        label: 'Financial Report Type',
        type: 'select',
        key: 'financialReportType',
        selectList: [],
      },
    ]
    const tableModel = [
      {
        label: 'Financial Report Type',
        slotName: 'type',
      },
      {
        // financialReportName
        label: 'Financial Report Name',
        slotName: 'name',
      },
      {
        label: 'Financial Report Time',
        slotName: 'reportYear',
      },
      {
        label: 'Period Ending',
        prop: 'fiscalYearEndDate',
      },
      {
        label: 'Currency',
        prop: 'currency',
      },
      {
        label: 'Account Type',
        slotName: 'accountType',
      },
      {
        label: `Auditors'opinion`,
        slotName: 'auditorsOpinion',
      },
      // {
      //   label: 'Modified by',
      //   prop: 'operator',
      // },
      {
        width: 100,
        label: 'Action',
        slotName: 'action',
      },
    ]
    return {
      searchModel,
      tableModel,
      tableData: [],
      pages: {},
      form: {
        fiscalYearEndDate: '',
        type: '',
        companyId: this.$route.params.customerId,
        reportYear: '',
        currency: '',
        reportQuarter: '',
        accountType: '',
        auditorsOpinion: '',
        exchangeDate: '',
        exchangeRate: '',
      },
      visible: false,
      uploadUrl: commonUploadUrl,
      fileList: [],
      typeList: [
        {
          name: 'Annual Report',
          id: 1,
        },
        {
          name: 'Interim Report',
          id: 2,
        },
      ],
    }
  },
  filters: {
    type: (id, typeList) => {
      const res = typeList.filter(item => item.id === id)
      return res ? res[0].name : ''
    },
    q: (id, QList) => {
      const res = QList.filter(item => item.id === id)
      return res ? res[0].name : ''
    },
  },
  mounted() {
    this.searchModel[0].selectList = this.typeList
    this.initTable()
  },
  methods: {
    // 获取转换
    async _getCurrenyRate() {
      const { rate } = await getCurrenyRate(
        this.form.type === 2
          ? this.form.exchangeDate || this.form.fiscalYearEndDate
          : this.form.exchangeDate,
        this.form.currency,
      )
      this.form.exchangeRate = rate
    },
    filterNameAccountType(status) {
      switch (status) {
        case 1:
          return 'Consolidated'
        case 2:
          return 'Stand alone'
      }
    },
    filterNameAuditorsOpinion(status) {
      switch (status) {
        case 1:
          return 'Unqualified'
        case 2:
          return 'With Remarks'
        case 3:
          return 'Qualified'
        case 4:
          return 'Non-audited'
      }
    },
    handleChangeCurrency(currency) {
      if (currency === 'USD') {
        console.log('美元')
      }
    },
    async handleRemoveItem(id) {
      try {
        await removeItem(id)
        this.initTable()
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
    },
    handleTemplateDownload() {
      templateDownload()
    },
    async handleAddBtn() {
      await this._getCurrencyList()
      this.visible = true
    },
    async _getCurrencyList() {
      try {
        this.currencyList = await getCurrencyList()
      } catch (err) {
        console.error(err)
      }
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async handleDownloadItem(row) {
      try {
        await commonDownload(row.attachmentId)
      } catch (err) {
        console.error(err)
      }
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData({
          ...params,
          companyId: this.$route.params.customerId,
        })
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    handleClose() {
      this.fileList = []
      this.$refs.form.resetFields()
      this.reportQuarter = ''
    },
    async handleUpload() {
      const formData = new FormData()
      this.fileList.forEach(item => {
        formData.append('file', item.raw)
      })
      Object.keys(this.form).forEach(key => {
        formData.append(key, this.form[key])
      })
      return await commonUpload(formData)
    },
    async handleSubmit() {
      if (this.form.type === 2 && !this.form.fiscalYearEndDate) {
        return this.$message.warning('Please upload Fiscal Year Date')
      }
      if (!this.form.type) {
        return this.$message.warning('Please upload Financial Report Type')
      }
      if (!this.form.reportYear) {
        return this.$message.warning('Please upload Financial Report Time')
      }
      if (!this.form.currency) {
        return this.$message.warning('Please upload Currency')
      }
      try {
        const id = await this.handleUpload()
        const submitData = {
          ...this.form,
          attachmentId: id,
          companyId: this.$route.params.customerId,
        }
        if (this.form.currency === 'USD') {
          submitData.exchangeRate = '1'
        }
        await addCompanyFinances(submitData)
        this.initTable()
        this.$message.success('success')
        this.visible = false
      } catch (err) {
        console.error(err)
      }
    },
    handleChange(file) {
      this.fileList.splice(0, 1, file)
    },
    // handleUploadSuccess({ code, msg, data }) {
    //   if (code === ERR_OK) {
    //     this.$message.success('success')
    //     this.uploadId = data
    //   } else {
    //     this.$message.error(msg)
    //     this.fileList.pop()
    //   }
    // },
  },
  watch: {
    form: {
      deep: true,
      handler(newVal) {
        if (newVal.type === 1) {
          if (newVal.currency === 'USD') {
            return false
          } else if (newVal.exchangeDate && newVal.currency) {
            this._getCurrenyRate()
          }
        } else {
          if (newVal.currency && newVal.exchangeDate) {
            this._getCurrenyRate()
          }
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.el-upload) {
  width: 100%;
}

.download-template-btn {
  width: 100%;
  text-align: center;
  font-size: 16px;
  color: #4458fe;
  line-height: 40px;
  margin-top: 20px;
}

.file-wrapper {
  width: 100%;

  width: 100%;
  text-align: center;
  line-height: 30px;
  font-size: 16px;
  color: #3a3f63;
  @include no-wrap();
}
</style>
